import RouteItem from ".";
import PageUnderConstruction from "../pages/error-page/PageUnderConstruction";
//Muhs Mandate Pages
import Muhs2020_21 from "../pages/muhsMandate/Muhs2020_21";
import Muhs2021_22 from "../pages/muhsMandate/Muhs2021_22";
import Muhs2022_23 from "../pages/muhsMandate/Muhs2022_23";
import Muhs2023_24 from "../pages/muhsMandate/Muhs2023_24";
import Muhs2024_25 from "../pages/muhsMandate/Muhs2024_25";
import Muhs2025_26 from "../pages/muhsMandate/Muhs2025_26";
import Muhs2026_27 from "../pages/muhsMandate/Muhs2026_27";

export const muhsRoutes: RouteItem =
//muhs page route
{
  key: "router-muhs-mandate",
  title: "Muhs Mandate",
  tooltip: "Muhs Mandate",
  path: "/muhs-mandate",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-muhs-mandate-2026-27",
      title: "2026-27",
      tooltip: "Muhs Mandate 2026-27",
      path: "muhs-mandate-2026-27",
      enabled: true,
      component: Muhs2026_27,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2025-26",
      title: "2025-26",
      tooltip: "Muhs Mandate 2025-26",
      path: "muhs-mandate-2025-26",
      enabled: true,
      component: Muhs2025_26,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2024-25",
      title: "2024-25",
      tooltip: "Muhs Mandate 2024-25",
      path: "muhs-mandate-2024-25",
      enabled: true,
      component: Muhs2024_25,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2023-24",
      title: "2023-24",
      tooltip: "Muhs Mandate 2023-24",
      path: "muhs-mandate-2023-24",
      enabled: true,
      component: Muhs2023_24,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2022-23",
      title: "2022-23",
      tooltip: "Muhs Mandate 2022-23",
      path: "muhs-mandate-2022-23",
      enabled: true,
      component: Muhs2022_23,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2021-22",
      title: "2021-22",
      tooltip: "Muhs Mandate 2021-22",
      path: "muhs-mandate-2021-22",
      enabled: true,
      component: Muhs2021_22,
      appendDivider: true,
    },
    {
      key: "router-muhs-mandate-2020-21",
      title: "2020-21",
      tooltip: "Muhs Mandate 2020-21",
      path: "muhs-mandate-2020-21",
      enabled: true,
      component: PageUnderConstruction,
      appendDivider: true,
    },
  ],
};
